import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {



   //_url = 'http://localhost/reception';

//_url= 'http://multiinspectionreport.com/reception/api';
//_url= 'https://test.appointele.com/api';
//_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
   
  message = [];
  alltodaysapointment=[];
  userappointment=[];
  myappoinment=[];
 branchs=[];
 salesrepbybranch=[];
 alltimeslot:any=[];
mix=[];
 allappointmentchart=[];
 years=[];

  constructor(private _http: HttpClient) { }



  
  getSalesRepAppointmentForTodayByIDMainTable(salesRepID, branch: any) {
    return this._http.get(`${this._url}/salesrep_appointment_for_today_by_id_maintable_get.php?salesRep=${salesRepID}&branch=${branch}`).pipe(
      map((res) => {
      
        //console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/********************************************************* */ 
    getSalesRepAppointmentByIDMainTable(salesRepID, branch: any) {
      return this._http.get(`${this._url}/salesrep_appointment_by_id_maintable_get.php?salesRep=${salesRepID}&branch=${branch}`).pipe(
        map((res) => {
        
          //console.log(res);
          
          return [res];
      }),
      
      catchError(this.handleError));
    }
  /********************************************************* */ 
  getClientPreviousAppointment(clientID: string, clientName: any, clientPhoneNumber: any) {
    return this._http.get(`${this._url}/client_previous_appointment_by_PID_get.php?clientID=${clientID}&clientName=${clientName}&clientPhoneNumber=${clientPhoneNumber}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
 /********************************************************* */ 
  getClientUpcomingAppointment(clientID: string, clientName: any, clientPhoneNumber: any) {
    return this._http.get(`${this._url}/client_upcoming_appointment_by_PID_get.php?clientID=${clientID}&clientName=${clientName}&clientPhoneNumber=${clientPhoneNumber}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
 /********************************************************* */ 
  getAllClientAppointmentByPID(clientID: string, clientName: any, clientPhoneNumber: any) {
    return this._http.get(`${this._url}/all_client_appointments_get_by_pid.php?clientID=${clientID}&clientName=${clientName}&clientPhoneNumber=${clientPhoneNumber}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
  /********************************************************* */ 
  updateBrowsingAppointmentWithSalesRep(assignSalesRepBrowsingForm) {
   
    return this._http.post<any>(`${this._url}/browsing_appointment_with_salesrep_update.php`, assignSalesRepBrowsingForm)
  }

 /********************************************************* */ 
    insertNewAppointment(questionaireForm) {
   
    return this._http.post<any>(`${this._url}/new_appointment_insert.php`, questionaireForm)
  }
 /********************************************************* */ 
 sendAutoEmailUponAppointment(details){
  return this._http.post<any>(`${this._url}/send_email_upon_appointment.php`, details)
 }
 /********************************************************* */ 
 insertNewLogisticAppointment(questionaireForm) {
   
  return this._http.post<any>(`${this._url}/new_logistic_appointment_insert.php`, questionaireForm)
}

/********************************************************* */
  insertNewAppointmentByReception(questionaireForm) {
   
    return this._http.post<any>(`${this._url}/new_appointment_by_reception_insert.php`, questionaireForm)
  }
/***************************************************************** */
customAppointmentSearch(searchForm){
  return this._http.post<any>(`${this._url}/custom_appointment_search_get.php`, searchForm)
}

/********************************************************* */
searchClient(phoneNumber) {
  console.log(phoneNumber);
  return this._http.get(`${this._url}/search_client_by_phoneNumber_get.php?phoneNumber=${phoneNumber}`)
  .pipe(    map((res) => {
    //console.log(res);
    return res;
}),

catchError(this.handleError));
}
/********************************************************* */
getAllClient() {
 
  return this._http.get(`${this._url}/all_clients_get.php`)
  .pipe(    map((res) => {
    //console.log(res);
    return res;
}),

catchError(this.handleError));
}
/********************************************************* */

  searchAppointment(fullName,email,phoneNumber,branch,covid) {
    console.log(fullName, email,phoneNumber,branch,covid);
    return this._http.get(`${this._url}/active_appointment_by_fullName_get.php?fullName=${fullName}&email=${email}&phoneNumber=${phoneNumber}&branch=${branch}&covid=${covid}`)
    .pipe(    map((res) => {
      //console.log(res);
     // this.realestatesingleworksheet= res['data'];
      //console.log(this.realestatesingleworksheet);
      return res;
  }),
  
  catchError(this.handleError));
  }

/********************************************************* */
getArrangedSalesRepForBrowsing(branch){
  console.log(branch);//
  return this._http.get(`${this._url}/arranged_sales_rep_for_browsing_get.php?branch=${branch}`)
  .pipe(    map((res) => {
  //  console.log(res);
    return res;
}),

catchError(this.handleError));

}
/********************************************************* */
resetArrangedSalesRepForBrowsing(branch){
  console.log(branch);
  return this._http.get(`${this._url}/arranged_sales_rep_for_browsing_delete.php?branch=${branch}`)
  .pipe(    map((res) => {
   // console.log(res);
    return res;
}),

catchError(this.handleError));
}
/********************************************************* */
  getSalesRepByPID(pid,branch){
    console.log(pid,branch);
    return this._http.get(`${this._url}/sales_rep_by_pid_get.php?pid=${pid}&branch=${branch}`)
    .pipe(    map((res) => {
     // console.log(res);
     // this.realestatesingleworksheet= res['data'];
      //console.log(this.realestatesingleworksheet);
      return res;
  }),
  
  catchError(this.handleError));
}
/********************************************************* */

  getSalesRepByBranch(branch){
    return this._http.get(`${this._url}/salesrep_by_branch_get.php?branch=${branch}`).pipe(
       
       map((res) => {
        this.salesrepbybranch=[res];
       //  console.log(Object.assign(this.salesrepbybranch[0]));
         //console.log(len);
         return this.salesrepbybranch[0];
        //return len;
     }),

       catchError(this.handleError));
   }
/********************************************************* */   

   getMainSalesRepByBranch(branch){
    return this._http.get(`${this._url}/salesrep_by_branch_get_main.php?branch=${branch}`).pipe(
       
       map((res) => {
        this.salesrepbybranch=[res];
       //  console.log(Object.assign(this.salesrepbybranch[0]));
         //console.log(len);
         return this.salesrepbybranch[0];
        //return len;
     }),

       catchError(this.handleError));
   }
  /*************************************************************************** */
   deleteSalesRepFromMainList(loggedInUser,item){
    
    
    item['loggedInUser']=loggedInUser;
    //console.log(item);
    return this._http.post<any>(`${this._url}/salesRep_from_mainList_delete.php?`,item);
  }
    /*************************************************************************** */
  updateSalesRepListForBrowsing(salesRepListwithbranch){
   
  return this._http.post<any>(`${this._url}/arranged_salesRep_for_browsing_insert.php`, salesRepListwithbranch)
}

  /*************************************************************************** */


  /*************************************************************************** */
add_new_salesRep_to_mainlist_insert(addSalesRepToMainList){
  return this._http.post<any>(`${this._url}/salesRep_to_mainlist_insert.php`, addSalesRepToMainList)
}

/*************************************************************************** */
add_multiple_new_salesRep_to_mainlist_insert(addMultipleSalesRepToMainList){
  return this._http.post<any>(`${this._url}/multiple_salesRep_to_mainlist_insert.php`, addMultipleSalesRepToMainList)
}

/*************************************************************************** */
getAllYears(){
  return this._http.get(`${this._url}/years_get.php`).pipe(
    map((res) => {
    
      return res;
  }),
  
  catchError(this.handleError));
  }
/*************************************************************************** */
  getAllBranchs(){
    return this._http.get(`${this._url}/get_all_branchs.php`).pipe(
      map((res) => {
        this.branchs = res['data'];
        return this.branchs;
    }),
    
    catchError(this.handleError));
    }
/*************************************************************************** */
  getAllTodaysAppointmentWithoutLunch(branch){
    return this._http.get(`${this._url}/active_appointment_for_today_get_without_lunch.php?branch=${branch}`).pipe(
      map((res) => {
        //this.alltodaysapointment = res;
       // console.log(this.alltodaysapointment);
        //return this.alltodaysapointment;
        return res;
    }),
  
    catchError(this.handleError));
   
    }
    /*************************************************************************** */
    getAllBrowsingAppointmentForToday(branch,queryDate){
      return this._http.get(`${this._url}/all_browsing_appointment_for_today_without_salesrep.php?branch=${branch}&queryDate=${queryDate}`).pipe(
        map((res) => {
          //this.alltodaysapointment = res;
         // console.log(this.alltodaysapointment);
          //return this.alltodaysapointment;
          return res;
      }),
    
      catchError(this.handleError));
     
      }
/*************************************************************************** */
    getSalesRepFreeTime(branch,queryDate){
      return this._http.get(`${this._url}/sales_rep_available_slot_for_today_for_branch.php?branch=${branch}&queryDate=${queryDate}`).pipe(
        map((res) => {
          //this.alltodaysapointment = res;
         console.log(res);
          //return this.alltodaysapointment;
          return res;
      }),
    
      catchError(this.handleError));
     
      }
/*************************************************************************** */
getSalesRepFreeForNext30(branch,queryDate){
  return this._http.get(`${this._url}/sales_rep_to_assign_browsing_today_for_branch.php?branch=${branch}&queryDate=${queryDate}`).pipe(
    map((res) => {
      //this.alltodaysapointment = res;
     // console.log(this.alltodaysapointment);
      //return this.alltodaysapointment;
      return res;
  }),

  catchError(this.handleError));
 
  }
/*************************************************************************** */
getSalesRepToAssignBrowsing(branch,queryDate){
  return this._http.get(`${this._url}/sales_rep_to_assign_browsing_today_for_branch.php?branch=${branch}&queryDate=${queryDate}`).pipe(
    map((res) => {
      //this.alltodaysapointment = res;
     // console.log(this.alltodaysapointment);
      //return this.alltodaysapointment;
      return res;
  }),

  catchError(this.handleError));
 
  }
   /*************************************************************************** */   
    getTodayPersonCount(branch){
      return this._http.get(`${this._url}/report_today_personCount_get.php?branch=${branch}`).pipe(
        map((res) => {
          //this.alltodaysapointment = res;
         // console.log(this.alltodaysapointment);
          //return this.alltodaysapointment;
          return res;
      }),
    
      catchError(this.handleError));
     
      }


/*************************************************************************** */
    getAllActiveAppointmentForBranchForTimeSlot(branch){
      return this._http.get(`${this._url}/active_all_appointment_for_branch_get_for_timeslot.php?branch=${branch}`).pipe(
        map((res) => {
          this.alltimeslot= res;
         // console.log(res);
          //return this.alltodaysapointment;
          return this.alltimeslot;
      }),
    
      catchError(this.handleError));
     
      }

     /*************************************************************************** */
    getAllAppointmentForBranch(branch){
      return this._http.get(`${this._url}/active_all_appointment_for_branch_get_without_lunch.php?branch=${branch}`).pipe(
        map((res) => {
          //this.alltodaysapointment = res;
          //console.log(res);
          //return this.alltodaysapointment;
          return res;
      }),
    
      catchError(this.handleError));
     
      }
 /*************************************************************************** */
 getAllUpcomingAppointmentForBranch(branch){
  return this._http.get(`${this._url}/active_all_upcoming_appointment_for_branch_get_without_lunch.php?branch=${branch}`).pipe(
    map((res) => {
      //this.alltodaysapointment = res;
      //console.log(res);
      //return this.alltodaysapointment;
      return res;
  }),

  catchError(this.handleError));
 
  }      
/*************************************************************************** */
    assignLunchToSalesRep(lunchForm){
      return this._http.post<any>(`${this._url}/sales_rep_lunch_insert.php`, lunchForm)

    }
/*************************************************************************** */
    getMyAppointment(salesRep){
      return this._http.get(`${this._url}/active_appointment_for_salesrep_get.php?salesRep=${salesRep}`).pipe(
       
        map((res) => {
         this.myappoinment=[res];
         // console.log(this.myappoinment);
          //console.log(len);
          return this.myappoinment[0];
         //return len;
      }),
 
        catchError(this.handleError));
    }
 /*************************************************************************** */      
    getLunchAssignment(pid,salesRep,lunchTime,branch){
      return this._http.get(`${this._url}/lunch_assignment_by_pid_get.php?pid=${pid}&salesRep=${salesRep}&lunchTime=${lunchTime}&branch=${branch}`)
      .pipe(    map((res) => {
      //  console.log(res);
        return res[0];
    }),
    
    catchError(this.handleError));
    }
  /*************************************************************************** */
    
    deleteLunchAssignment(lunchForm){
      return this._http.post<any>(`${this._url}/sales_rep_lunch_delete.php`, lunchForm)

    }

    /*********************************************************************** */
  getUserExpertiseForForm(){
    return this._http.get(`${this._url}/user_expertise_get.php`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return res;
  }),
  
  catchError(this.handleError));
  }

    /*********************************************************************** */
    getUserExpertiseForFormByLocation(locationID){
      return this._http.get(`${this._url}/user_expertise_get.php?locationID=${locationID}`).pipe(
      map((res) => {
       
        //console.log(res);
        
        return res;
    }),
    
    catchError(this.handleError));
    }
/*************************************************************************** */    
  getAllAppointmentVegaPerMonth(year){
    return this._http.get(`${this._url}/report_all_appointments_vega_per_month_get.php?year=${year}`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentLawrencePerMonth(year){
    return this._http.get(`${this._url}/report_all_appointments_lawrence_per_month_get.php?year=${year}`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentStLaurentPerMonth(year){
    return this._http.get(`${this._url}/report_all_appointments_stlaurent_per_month_get.php?year=${year}`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentJanePerMonth(year){
    return this._http.get(`${this._url}/report_all_appointments_jane_per_month_get.php?year=${year}`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentForBranchPerMonth(branch,year){
    return this._http.get(`${this._url}/report_all_appointments_for_branch_per_month_get.php?branch=${branch}&year=${year}`).pipe(
    map((res) => {
     
      //console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }

/*************************************************************************** */
  getAllSalesRepCompletedAppointment(year){
    return this._http.get(`${this._url}/all_sales_rep_completed_appointments_get.php?year=${year}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

  /*************************************************************************** */
  getAllSalesRepCompletedAppointmentForBranch(branch,year){
    return this._http.get(`${this._url}/all_sales_rep_completed_appointments_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


/*************************************************************************** */
  getAllAppointmentLookingForEachMonthFor(month,year){
    console.log(month);
    return this._http.get(`${this._url}/all_appointments_lookingFor_each_month_get.php?month=${month}&year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentdescribesYouEachMonthFor(month,year){
    console.log(month);
    return this._http.get(`${this._url}/all_appointments_describesYou_each_month_get.php?month=${month}&year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
  /*************************************************************************** */
  getAllAppointmentrequestTypeEachMonthFor(month,year){
    console.log(month);
    return this._http.get(`${this._url}/all_appointments_requestType_each_month_get.php?month=${month}&year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */  
  getAllAppointmentLookingForEachMonthForBranch(month,branch,year){
    console.log(month,branch);
    return this._http.get(`${this._url}/all_appointments_lookingFor_each_month_for_branch_get.php?month=${month}&branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentdescribesYouEachMonthForBranch(month,branch,year){
    console.log(month);
    return this._http.get(`${this._url}/all_appointments_describesYou_each_month_for_branch_get.php?month=${month}&branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

  /*************************************************************************** */
  getAllAppointmentrequestTypeEachMonthForBranch(month,branch,year){
    console.log(month);
    return this._http.get(`${this._url}/all_appointments_requestType_each_month_for_branch_get.php?month=${month}&branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


/*************************************************************************** */
  getAllAppointmentLookingFor(year){
    return this._http.get(`${this._url}/all_appointments_lookingFor_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

 /*************************************************************************** */ 
  getAllAppointmentDescribesYou(year){
    return this._http.get(`${this._url}/all_appointments_describesYou_get.php?year=${year}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */  
  getAllAppointmentLookingForForBranch(branch, year){
    return this._http.get(`${this._url}/all_appointments_lookingFor_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentDescribesYouForBranch(branch,year){
    return this._http.get(`${this._url}/all_appointments_describesYou_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentCountAllBranch(year){
    return this._http.get(`${this._url}/all_appointments_count_get.php?year=${year}`).pipe(
      map((res) => {
       
     //   console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentCountForBranch(branch,year){
    return this._http.get(`${this._url}/all_appointments_count_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
     //   console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllLookDescReqCountAllBranch(year){
    return this._http.get(`${this._url}/all_lookingFor_describesYou_requestType_count_get.php?year=${year}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return res;
    }),
    
    catchError(this.handleError));
  }

  /*************************************************************************** */
  getAllSalesRepCountAllBranch(year){
    return this._http.get(`${this._url}/all_salesrep_count_get.php?year=${year}`).pipe(
      map((res) => {
       
       // console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

  /*************************************************************************** */
  getAllSalesRepCountForBranch(branch,year){
    return this._http.get(`${this._url}/all_salesrep_count_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
      //  console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


/*************************************************************************** */  
  getpopulardescribeYouAllBranch(year){
    return this._http.get(`${this._url}/popular_describesYou_all_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


  getpopularlookingForAllBranch(year){
    return this._http.get(`${this._url}/popular_lookingFor_all_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


/*************************************************************************** */    
  getpopulardescribeYouForBranch(branch,year){
    return this._http.get(`${this._url}/popular_describesYou_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }


  getpopularlookingForForBranch(branch,year){
    return this._http.get(`${this._url}/popular_lookingFor_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getallappointmentrequesttypeforeachbranchsquare(year){
    return this._http.get(`${this._url}/all_appointments_requestType_count_each_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getallappointmentrequesttypeforbranchsquare(branch, year){
    return this._http.get(`${this._url}/all_appointments_requestType_count_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentRequestType(year){
    return this._http.get(`${this._url}/all_appointments_requestType_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentRequestTypeForBranch(branch, year){
    return this._http.get(`${this._url}/all_appointments_requestType_for_branch_get.php?branch=${branch}&year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllAppointmentRequestTypeselection(selection){
    return this._http.get(`${this._url}/all_appointments_requestType_get.php?selection=${selection}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */
  getAllAppointmentFromAllBranchsPerMonth(year){
    return this._http.get(`${this._url}/total_appointments_from_all_branchs_get.php?year=${year}`).pipe(
    map((res) => {
     
      console.log(res);
      
      return [res];
  }),
  
  catchError(this.handleError));
  }
/*************************************************************************** */
  getAlllookingForAllBranch(year){
    return this._http.get(`${this._url}/all_appointments_lookingFor_all_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */  
  getAlldescribesYouAllBranch(year){
    return this._http.get(`${this._url}/all_appointments_describesYou_all_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }

/*************************************************************************** */  
  getAllrequestTypeAllBranch(year){
    return this._http.get(`${this._url}/all_appointments_requestType_all_branch_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getAllRequestTypeAllBranchPerMonth(year){
    return this._http.get(`${this._url}/all_appointments_requestType_with_filter_get.php?year=${year}`).pipe(
      map((res) => {
       
        console.log(res);
        
        return [res];
    }),
    
    catchError(this.handleError));
  }
/*************************************************************************** */
  getUserAppointment(pid,fullName,phoneNumber,branch,timeIn){
    return this._http.get(`${this._url}/user_appointment_by_pid_get.php?pid=${pid}&fullName=${fullName}&phoneNumber=${phoneNumber}&branch=${branch}&timeIn=${timeIn}`)
    .pipe(    map((res) => {
     console.log(res);
      return res[0];
  }),
  
  catchError(this.handleError));
  }
  /*************************************************************************** */
  UpdateNotesForAppointment(notesForm) {
    console.log(notesForm)
    
    return this._http.post<any>(`${this._url}/appointment_notes_update.php`, notesForm)
    }
/***************************************** */
getClientDetails(pid,fullName,phoneNumber){
  //console.log(pid);
  return this._http.get(`${this._url}/client_details_by_pid_get.php?pid=${pid}&fullName=${fullName}&phoneNumber=${phoneNumber}`)
  .pipe(    map((res) => {
    console.log(res);
    return res[0];
}),

catchError(this.handleError));
}
/*************************************************************************** */
  updateAppointment(appointmentForm) {
    console.log(appointmentForm)
    return this._http.post<any>(`${this._url}/appointment_update.php`, appointmentForm)
  }
/*************************************************************************** */
  salesrepDayOffAssignment(dayoffForm) {
    console.log(dayoffForm)
    return this._http.post<any>(`${this._url}/salesrep_dayoff_insert.php`, dayoffForm)
  }
/*************************************************************************** */
  multipleSalesrepDayOffAssignment(dayoffForm) {
    console.log(dayoffForm)
    return this._http.post<any>(`${this._url}/multiple_salesRep_dayoff_insert.php`, dayoffForm)
  }
/*************************************************************************** */
//new ways- multiple dates lunch assignment
multipleSalesrepWithMultipleDayOffAssignment(lunchForm) {
  console.log(lunchForm)
  return this._http.post<any>(`${this._url}/multiple_salesRep_multiple_dayoff_insert.php`, lunchForm)
}
/*************************************************************************** */
//new ways- multiple dates lunch assignment
multipleSalesrepWithMultipleDatesLunchAssignment(lunchForm) {
  console.log(lunchForm)
  return this._http.post<any>(`${this._url}/multiple_salesRep_multiple_dates_lunch_insert.php`, lunchForm)
}
/*************************************************************************** */
//oldluch assignment with one date
  multipleSalesrepLunchAssignment(lunchForm) {
    console.log(lunchForm)
    return this._http.post<any>(`${this._url}/multiple_salesRep_lunch_insert.php`, lunchForm)
  }
/*************************************************************************** */
  salesrepBlockOffDayAssignment(blockoffdayForm) {
    console.log(blockoffdayForm)
    return this._http.post<any>(`${this._url}/salesrep_blockoffday_insert.php`, blockoffdayForm)
  }
/*************************************************************************** */
  multipleSalesrepBlockOffDayAssignment(blockoffdayForm) {
    console.log(blockoffdayForm)
    return this._http.post<any>(`${this._url}/multiple_salesRep_blockoff_insert.php`, blockoffdayForm)
  }
/*************************************************************************** */
  updateUserAppointmentTag(tagForm) {
    console.log(tagForm)
    return this._http.post<any>(`${this._url}/user_appointment_tag_update.php`,tagForm)
  }
/*************************************************************************** */
  deleteAppointmentbypid(appointment){
  //  console.log(appointment);
    //type is any and we are posting userData and return response as Observable
    return this._http.post<any>(`${this._url}/delete_appointment_by_pid.php`,appointment);
    }	
/*************************************************************************** */
setAppointmentStatusbypid(appointment){
  //console.log(appointment);
  //type is any and we are posting userData and return response as Observable
  return this._http.post<any>(`${this._url}/set_status_appointment_by_pid.php`,appointment);
  }	
  /*************************************************************************** */
setAppointmentCompletebypid(appointment){
  //console.log(appointment);
  //type is any and we are posting userData and return response as Observable
  return this._http.post<any>(`${this._url}/set_complete_appointment_by_pid.php`,appointment);
  }	
/*************************************************************************** */
  sendAppointmentEmailToClient(appointment){
    console.log(appointment);
    //type is any and we are posting userData and return response as Observable
    return this._http.post<any>(`${this._url}/send_appointment_email_to_client.php`,appointment);
    }	
/*************************************************************************** */  
  clearbarScanbypid(appointment){
    //console.log(appointment);
    //type is any and we are posting userData and return response as Observable
    return this._http.post<any>(`${this._url}/clear_barScan_appointment_by_pid.php`,appointment);
    }	
  /*************************************************************************** */
    private handleError(error: HttpErrorResponse) {
   // console.log(error);
  
   
    // return an observable with a user friendly message
    return throwError('Error! something went wrong.');
  }
 
  
}
